const IATA_CODE = /^[A-Z]{3}$/;

export const isAirportCode = (code: string) => IATA_CODE.test(code);

export const normaliseAirportCodes = (codes: Array<string>) => [
  ...new Set(codes.map((code) => code.trim().toUpperCase()).filter(Boolean)),
];

export function getFlightErrorMessage(error: unknown, destinationAirport: string) {
  switch ((error as { status?: number }).status) {
    case 400:
      return 'Airport codes must be 3-letter IATA codes.';
    case 409:
      return `This bundle already has flights to ${destinationAirport}. Edit that flight's origins instead.`;
    case 422:
      return 'An origin airport cannot be the same as the destination.';
    default:
      return error instanceof Error ? error.message : 'Failed to save flight';
  }
}
